import request from '@/utils/request'
//提交正式考试
export function SubmitExam(examId,userId,processId,sumScore,IsCheat,data) {
    return request({
        url: `/api/Exam/SubmitExam?examId=${examId}&userId=${userId}&processId=${processId}&sumScore=${sumScore}&IsCheat=${IsCheat?'true':'false'}`,
        method: 'post',
        data
    })
}
//即将开始考试
export function BegingList(params) {
    return request({
        url: '/api/Exam/BegingList',
        method: 'get',
        params
    })
}

//正在进行考试
export function StartList(params) {
    return request({
        url: '/api/Exam/StartList',
        method: 'get',
        params
    })
}

//证书首页警种统计
export function JzIndexTongJi(params) {
    return request({
        url: '/api/Exam/JzIndexTongJi',
        method: 'get',
        params
    })
}

//证书首页地市统计
export function JzIndexCity(params) {
    return request({
        url: '/api/Exam/JzIndexCity',
        method: 'get',
        params
    })
}


//查询试卷
export function SelectExam(params) {
    return request({
        url: '/api/Exam/LoadQT',
        method: 'get',
        params
    })
}

//删除试卷
export function DeleteExam(data) {
    return request({
        url: '/api/Exam/Delete',
        method: 'post',
        data
    })
}

//获取改卷教官
export function SelectDrillMaster(params) {
    return request({
        url: '/api/Exam/GetCorrectUser',
        method: 'get',
        params
    })
}

//获取考试人员情况
export function SelectUser(params) {
    return request({
        url: '/api/ExamProcess/Load',
        method: 'get',
        params
    })
}
//获取考试人员情况
export function GetExamTJInfo(params) {
    return request({
        url: '/api/ExamPeople/GetExamTJInfo',
        method: 'get',
        params
    })
}

//个人重考
export function GetAgenExam(params) {
    return request({
        url: '/api/Exam/GetAgenExam',
        method: 'get',
        params
    })
}
//进入信息
export function getExamProcessInfo(params) {
    return request({
        url: '/api/ExamProcess/GetExamProcessInfo',
        method: 'get',
        params
    })
}

//获取作弊设置
export function getCheat(params) {
    return request({
        url: '/api/ExamCheat/Get',
        method: 'get',
        params
    })
}

//修改作弊设置
export function updateCheat(data) {
    return request({
        url: '/api/ExamCheat/Update',
        method: 'post',
        data
    })
}

//考试成绩分析
export function getExamScoreTJ(params) {
    return request({
        url: '/api/Exam/GetExamScoreTJ',
        method: 'get',
        params
    })
}

//试题分析
export function getExamQuestionTj(params) {
    return request({
        url: '/api/Exam/GetExamQuestionTj',
        method: 'get',
        params
    })
}

//考试公布成绩
export function examOpen(params) {
    return request({
        url: '/api/Exam/ExamOpen',
        method: 'post',
        params
    })
}

//改卷正式考试
export function correctExam(params,data) {
    return request({
        url: '/api/Exam/CorrectExam',
        method: 'post',
        params,
        data
    })
}

//考试冻结
export function examFreeze(params) {
    return request({
        url: '/api/Exam/ExamFreeze',
        method: 'post',
        params
    })
}

//生成实操考试协议Url
export function getShiCaoUrl(params) {
    return request({
        url: '/api/Exam/GetShiCaoUrl',
        method: 'get',
        params
    })
}
//生成实操考试协议Url
export function getShiCaoUrlNew(params) {
    return request({
        url: '/api/Exam/GetShiCaoUrlNew',
        method: 'get',
        params
    })
}
//生成实操考试阅卷协议Urlnew
export function getShiCaoReadUrlNew(params) {
    return request({
        url: '/api/Exam/GetShiCaoReadUrlNew',
        method: 'get',
        params
    })
}

//开始实操考试
export function beginShiCao(params) {
    return request({
        url: '/api/ExamProcess/BeginShiCao',
        method: 'get',
        params
    })
}

